export default {
	data() {
		return {
			optionOrder: [],
			calculatedColumns: this.columns,
			elementWidth: 0
		};
	},
	props: {
		columns: { type: Number, default: 0 },
		options: { type: Array, default: null }
	},
	mounted() {
		if (this.columns > 0) {
			this.sortIntoColumns();
			window.addEventListener('resize', this.sortIntoColumns);
			this.addResetDataCallback(this.sortIntoColumns);
		}
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.sortIntoColumns);
	},
	computed: {
		hasColumns() {
			return this.calculatedColumns >= 1 && this.calculatedColumns <= 4;
		},
		columnClasses() {
			return `cog-inner-col cog-inner-col--${this.calculatedColumns}`;
		},
		minimumColWidth() {
			const baseColWidth = this.hideChoiceLabels || (this.isCard && this.cardLabelPosition === 'bottom') ? 0 : 130;
			const fontSizeMultiplier = parseInt(getComputedStyle(this.$el).fontSize) / 14;

			// Additions to baseColWidth are not precise. They don't take into account the theme settings.
			const colWidthCardAddition = this.isCard ? 7 : 0; // Cards have padding on either side but they don't have a checkable taking up space
			let colWidthImageAddition = 0;
			if (this.showChoiceImages)
				colWidthImageAddition = (this.choiceImageSize + 1) * 19 * (2.3 * fontSizeMultiplier);

			return baseColWidth + colWidthCardAddition + colWidthImageAddition;
		}
	},
	watch: {
		options() {
			if (this.columns > 0)
				this.sortIntoColumns();
		}
	},
	methods: {
		sortIntoColumns() {
			this.calculatedColumns = Math.max(1, Math.min(Math.floor(this.$el.clientWidth / this.minimumColWidth), this.columns));
			const numberOfColumns = this.calculatedColumns;
			const optionsAmt = this.readonly ? this.selectedOptions.length : this.options.length;
			const numberOfItems = this.allowOther && !this.readonly ? optionsAmt + 1 : optionsAmt;
			const itemsPerColumn = numberOfItems / numberOfColumns;

			let itemsPerColumnRounded = Math.ceil(itemsPerColumn);
			const partialColumns = numberOfColumns - (numberOfItems % numberOfColumns);
			let hasPartialColumns = partialColumns !== numberOfColumns;
			const columns = [];
			let col = 0; let row = -1;
			for (let i = 0; i < numberOfItems; i++) {
				row++;
				if (row >= itemsPerColumnRounded) {
					row = 0;
					col++;
				}
				columns[row * numberOfColumns + col] = i;
				if (hasPartialColumns && i + 1 === numberOfItems - (partialColumns * (itemsPerColumnRounded - 1))) {
					itemsPerColumnRounded--;
					hasPartialColumns = false;
				}
			}

			const options = [];
			for (let j = 0; j < numberOfItems; j++) {
				options[columns[j]] = j;
			}

			this.optionOrder = options;
		}
	}
};